<p>
  Use <strong>Edit Mode</strong> to switch between <code>dialog</code>, <code>inline-auto</code>, and
  <code>inline-button</code>.
  When <strong>inline-button</strong> is selected, use <strong>Inline Save/Cancel</strong> to switch between text,
  icon, or text+icon button styles.
  Use <strong>Add Button</strong> to choose no built-in create button, a button below the grid, or a button in the panel header.
  Enable <strong>Allow Delete</strong> to show row delete actions when supported by the selected mode.
</p>
<ul>
  <li><code>dialog</code>: Opens a form dialog for editing the selected row.</li>
  <li><code>inline-auto</code>: Click an editable cell to edit immediately in the grid row.</li>
  <li><code>inline-button</code>: Click <strong>Edit</strong> to enter row edit mode, then <strong>Save/Cancel</strong>.</li>
</ul>

<ui-form
  [config]="modeFormConfig"
  [(formValues)]="modeFormValues"
></ui-form>

<ui-grid
  [dsConfig]="dsConfig()"
  [agGridOptions]="agGridOptions"
  [panelHeaderConfig]="panelHeaderConfig()"
  [showPanelHeader]="true"
  [pageSizes]="[5, 10, 20]"
></ui-grid>
